/** @format */

import { Alert, Box, Chip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../app/hooks";
import DisplayFieldData from "../../../common/custom/DisplayFieldData";
import CircularLoader from "../../../common/loaders/circularLoader";
import { selectApplicant } from "../../applicant/ApplicantSlice";
import {
  ApplicantViewDto
} from "../../applicant/Models";
import "../../applicant/ViewInstitutionDetails.css";

export default function ViewInstitutionDetails() {
  const selectApplicantData = useAppSelector(selectApplicant);
  const [data, setData] = useState<ApplicantViewDto>();

  useEffect(() => {
    if (selectApplicantData.applicantState.applicant) {
      setData(selectApplicantData.applicantState.applicant);
    }
  }, [selectApplicantData.applicantState.applicant]);
  return (
    <>
      <CircularLoader status={selectApplicantData.applicantState.status} />

      {selectApplicantData.applicantState.status === "idle" && data && (
        <>
          {data.universityOfChoice && (
            <Alert sx={{ mb: 2 }} variant="standard">
              Successfull university choice: {data.universityOfChoice}
            </Alert>
          )}

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ width: "60%" }}>
              <DisplayFieldData
                header="Qualification start year"
                value={data?.studyDetails?.qualificationStartYear}
              />

              <DisplayFieldData
                header="Type of study"
                value={data?.studyDetails?.typeOfStudy}
              />
              <DisplayFieldData
                header="Year of study"
                value={data?.studyDetails?.yearOfStudy}
              />

              <Typography mt={1} fontWeight="bold" className="profile__headers">
                Institution of choice
              </Typography>
              <Box>
                {data?.studyDetails?.institutions.map((ins, key: React.Key) => (
                  <Chip
                    key={key}
                    sx={{
                      marginTop: "4px",
                      marginLeft: "4px",
                      borderRadius: "0px 5px 5px 0px",
                      borderLeft: "2px solid #1976d2",
                    }}
                    label={ins}
                  />
                ))}
              </Box>
            </Box>
            <Box sx={{ width: "40%" }}>
              <DisplayFieldData
                header="High school name"
                value={data?.educationDetails?.highSchoolName}
              />

              <DisplayFieldData
                header="  Still in High school"
                value={
                  data?.educationDetails?.matriculationYear >=
                  new Date().getFullYear()
                    ? "Yes"
                    : "No"
                }
              />

              <DisplayFieldData
                header="Matriculation Year"
                value={data?.educationDetails?.matriculationYear}
              />
              <DisplayFieldData
                header="High school Province"
                value={data?.educationDetails?.provinceName}
              />
              <DisplayFieldData
                header=" High School Subjects"
                value={data?.educationDetails?.subjects
                  .map((sub) => sub)
                  .join(", ")}
              />
            </Box>
          </Box>
        </>
      )}
    </>
  );
}
